var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2827 7.45307C15.5131 6.98613 15.6284 6.75266 15.7848 6.67807C15.9209 6.61317 16.0791 6.61317 16.2152 6.67807C16.3717 6.75266 16.4869 6.98613 16.7174 7.45307L18.9041 11.883C18.9721 12.0209 19.0061 12.0898 19.0558 12.1433C19.0999 12.1907 19.1527 12.2291 19.2113 12.2564C19.2776 12.2872 19.3536 12.2983 19.5057 12.3205L24.397 13.0355C24.9121 13.1107 25.1696 13.1484 25.2888 13.2742C25.3925 13.3836 25.4412 13.5341 25.4215 13.6835C25.3988 13.8553 25.2124 14.0369 24.8395 14.4001L21.3014 17.8462C21.1912 17.9536 21.136 18.0073 21.1004 18.0712C21.0689 18.1278 21.0487 18.19 21.0409 18.2543C21.0321 18.3269 21.0451 18.4027 21.0711 18.5545L21.906 23.4219C21.994 23.9352 22.038 24.1919 21.9553 24.3443C21.8833 24.4768 21.7554 24.5697 21.6071 24.5972C21.4366 24.6288 21.2061 24.5076 20.7451 24.2652L16.3724 21.9656C16.2361 21.8939 16.168 21.8581 16.0962 21.844C16.0327 21.8316 15.9673 21.8316 15.9038 21.844C15.832 21.8581 15.7639 21.8939 15.6277 21.9656L11.2549 24.2652C10.7939 24.5076 10.5634 24.6288 10.393 24.5972C10.2447 24.5697 10.1167 24.4768 10.0447 24.3443C9.962 24.1919 10.006 23.9352 10.0941 23.4219L10.9289 18.5545C10.9549 18.4027 10.9679 18.3269 10.9591 18.2543C10.9513 18.19 10.9311 18.1278 10.8996 18.0712C10.864 18.0073 10.8089 17.9536 10.6986 17.8462L7.16056 14.4001C6.78766 14.0369 6.60121 13.8553 6.57853 13.6835C6.55879 13.5341 6.60755 13.3836 6.71125 13.2742C6.83044 13.1484 7.08797 13.1107 7.60304 13.0355L12.4943 12.3205C12.6464 12.2983 12.7225 12.2872 12.7887 12.2564C12.8474 12.2291 12.9002 12.1907 12.9442 12.1433C12.9939 12.0898 13.0279 12.0209 13.096 11.883L15.2827 7.45307Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aa1e1a7d0c0249dc94a1f1a9596c0bdc.svg";
export { ForwardRef as ReactComponent };